import { CODE_PR_DEL, CODE_PR_DET, CODE_PR_LIST, CODE_PR_SAVE } from "../actions/action-types";
import { initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Liste des projets
export function ListProjectReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case CODE_PR_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détail d'un projet
export function DetailProjectReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case CODE_PR_DET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Sauvegarde d'un projet
export function SaveProjectReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_PR_SAVE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Suppression d'un projet
export function DeleteProjectReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_PR_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}
